import React from 'react';

import { BackButton } from '../../../../../../components/Clickables/Controls/BackButton/BackButton';
import { Heading } from '../../../../../../components/Heading/Heading';
import { ToggleableGroup } from '../../../../../../components/Maps/types/types';
import { useMapLayers } from '../../../../../../contexts/MapLayersContext';
import { trackEvent } from '../../../../../../helpers/analytics/trackEvent';
import { useExplore } from '../../../../context/ExploreContext';
import { MapDrawerLayout } from '../../MapDrawerLayout';
import { MapLayerSwitch } from '../MapLayersView/components/MapLayerSwitch';

export const FishingWaterSettingsView = () => {
  const { saveParamsInUrl } = useExplore();

  const {
    layers: {
      fishingWaters: { isWholeLayerVisible, toggleableGroups },
    },
    toggleLayer,
    toggleToggleableGroup,
  } = useMapLayers();

  const current = toggleableGroups.length;

  const handleOnClose = (): void => {
    if ((current === 0 && isWholeLayerVisible) || (current !== 0 && !isWholeLayerVisible)) {
      toggleLayer('fishingWaters');
    }

    saveParamsInUrl({
      drawerView: 'map-layers',
    });
  };

  const handleOnClick = (group: ToggleableGroup): void => {
    toggleToggleableGroup('fishingWaters', group);
    void trackEvent({
      name: 'mykiss_explore_sub_layer_toggled',
      properties: {
        layer_type: 'fishing_waters',
        state: toggleableGroups.includes(group),
      },
    });
  };

  return (
    <MapDrawerLayout
      withCloseButton={false}
      headerContent={
        <div>
          <BackButton variant="controlLakeFogBg" onClick={handleOnClose} />
          <Heading as="h1" variant="sm" className="mb-6">
            Fishing waters
          </Heading>
        </div>
      }
    >
      <div className="bg-sea-foam mt-4 rounded-lg pt-6">
        <Heading as="h2" variant="2xs" className="mx-4">
          Waters visible
        </Heading>
        <MapLayerSwitch
          title="Waters with catches"
          icon="fishing_water_with_catches"
          isActive={toggleableGroups.includes('FISHING_WATERS')}
          onClick={() => {
            handleOnClick('FISHING_WATERS');
          }}
          mapIconScale={1.0}
        />
        <MapLayerSwitch
          title="Waters with no catches"
          icon="fishing_water_without_catches"
          isActive={toggleableGroups.includes('EMPTY_FISHING_WATERS')}
          onClick={() => {
            handleOnClick('EMPTY_FISHING_WATERS');
          }}
          mapIconScale={1.0}
        />
        <MapLayerSwitch
          title="Prohibited waters"
          icon="forbidden_fishing_water"
          isActive={toggleableGroups.includes('FORBIDDEN_FISHING_WATERS')}
          onClick={() => {
            handleOnClick('FORBIDDEN_FISHING_WATERS');
          }}
          mapIconScale={0.9}
        />
      </div>
    </MapDrawerLayout>
  );
};
